export const PAGE_EVENT_CHANGED = "PAGE_EVENT_CHANGED";
